import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';

// Import slices
import authSlice from './slices/authSlice';
import uiSlice from './slices/uiSlice';
import formsSlice from './slices/formsSlice';
import dataSlice from './slices/dataSlice'; // Unificado: reemplaza apiSlice y catalogSlice
import lawyerDashboardSlice from './slices/lawyerDashboardSlice';
import clientDashboardSlice from './slices/clientDashboardSlice';

// Persist configuration
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth', 'forms'], // Solo persistir auth y forms
  blacklist: ['ui', 'data', 'lawyerDashboard', 'clientDashboard'], // No persistir UI, datos temporales y dashboards
};

// Root reducer
const rootReducer = combineReducers({
  auth: authSlice,
  ui: uiSlice,
  forms: formsSlice,
  data: dataSlice, // Unificado: reemplaza api y catalog
  lawyerDashboard: lawyerDashboardSlice,
  clientDashboard: clientDashboardSlice,
});

// Persisted reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Configure store
export const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST', 'persist/REHYDRATE'],
      },
    }),
  devTools: process.env.NODE_ENV !== 'production',
});

// Persistor for redux-persist
export const persistor = persistStore(store);

// Para TypeScript, estos tipos se exportarían así:
// export type RootState = ReturnType<typeof store.getState>;
// export type AppDispatch = typeof store.dispatch;
